import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const IconRow = ({ blok }) => {
  const { icons = [], dark_background } = blok;

  // Grid layout for 3 or 4 icons
  const gridCols = icons.length === 3 ? "md:grid-cols-3" : "md:grid-cols-4";

  return (
    <section
      {...storyblokEditable(blok)}
      className={`w-full ${dark_background ? "bg-[#00033E] text-white" : ""}`}
    >
      <div className="py-10 px-6 max-w-7xl mx-auto">
        <div className={`grid ${gridCols} gap-8 justify-items-center items-start`}>
          {icons.map((nestedBlok) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default IconRow;
